export default __webpack_public_path__ + "static/media/speaker-mute-grey.ab7ded22.svg";